import React, { Component } from 'react';
import classes from "./Chart_Village_SpeciesGender_Board.module.css";
import Chart_Village_SpeciesGender_LineChart from './Chart_Village_SpeciesGender_LineChart';

/* 
<p>The intersection of Gender and Species show some interesting relationships. For example, there are more Females who Cats, Rabbits, and Squirrels, while there are more Males who are Frogs. The Gender and Personalities are associated with traits that people usually see as feminine or masculine.</p>                
*/

export default class Chart_Village_SpeciesGender_Board extends Component {

    render() {
        return (
            <div className={classes.container}>
                <Chart_Village_SpeciesGender_LineChart />    
            </div>
        )
    }
}

/* Tutorial from:
     https://blog.bitsrc.io/customizing-chart-js-in-react-2199fa81530a
*/